import { UpdateType } from '../updates/index.js';
export const ISINCOURTUPDATESTYPES = [
    UpdateType.AWAITINGCIVILCOURT,
    UpdateType.AWAITINGFOGEDREKVISITION,
    UpdateType.ISINCIVILCOURT,
    UpdateType.ISINFOGEDRETTEN,
    UpdateType.AWAITINGSTAEVNING,
    UpdateType.PHONEMEETING,
];
//# sourceMappingURL=index.js.map